import { render } from "./ProyectoEstatusForm.vue?vue&type=template&id=6461f250&scoped=true"
import script from "./ProyectoEstatusForm.vue?vue&type=script&lang=js"
export * from "./ProyectoEstatusForm.vue?vue&type=script&lang=js"

import "./ProyectoEstatusForm.vue?vue&type=style&index=0&id=6461f250&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6461f250"]])

export default __exports__